import { Command } from '../command/command';
import { StepGuard } from '../../core/model/step-guard';


export class AddCurrentWizzardStep implements Command {
  readonly name = 'add_current_wizzard_step_kasko';

  constructor(private _step: StepGuard) {
  }

  get step(): StepGuard {
    return this._step;
  }
}

export class AddKaskoIdCommand implements Command {
  readonly name = 'add_kasko_id';

  constructor(private _id: string) {
  }

  get id(): string {
    return this._id;
  }
}

export class AddInitInfoCommand implements Command {
  readonly name = 'add_init_info_kasko';

  constructor(
    private _brand: string,
    private _model: string,
    private _purchasePhoneAmount: number,
  ) { }

  get brand(): string {
    return this._brand;
  }

  get model(): string {
    return this._model;
  }

  get purchasePhoneAmount(): number {
    return this._purchasePhoneAmount;
  }
}

export class AddPhoneInfoCommand implements Command {
  readonly name = 'add_phone_info_kasko';

  constructor(
    private _imei: string,
    private _imgReceiptUrl: string,
    private _note: string,
    private _purchaseDate: string, // DD/MM/YYYY
  ) { }

  get imei(): string {
    return this._imei;
  }

  get imgReceiptUrl(): string {
    return this._imgReceiptUrl;
  }

  get note(): string {
    return this._note;
  }

  get purchaseDate(): string {
    return this._purchaseDate;
  }
}

export class AddKaskoCustomerTypeCommand implements Command {
  readonly name = 'add_customer_type_kasko';

  constructor(private _type: string) {
  }

  get type(): string {
    return this._type;
  }
}

export class AddKaskoCustomerIdCommand implements Command {
  readonly name = 'add_customer_id_kasko';

  constructor(private _id: string) {
  }

  get id(): string {
    return this._id;
  }
}

export class AddKaskoPaymentIdCommand implements Command {
  readonly name = 'add_payment_id_kasko';

  constructor(private _id: string) {
  }

  get id(): string {
    return this._id;
  }
}



// WEBPACK FOOTER //
// ./src/app/state/kasko/kasko-commands.ts